export const mapFlagName = (flag) => {
    switch (flag) {
        case 'found_illeterate_person_text':
            return 'Pessoa analfabeta'
        case 'multiple_people':
            return 'Múltiplas pessoas'
        case 'document_edges_issue':
            return 'Parte do documento foi ocultada'
        case 'found_state_text':
            return 'Encontrou estado'
        case 'found_footer_text':
            return 'Encontrou rodapé'
        case 'found_header_text':
            return 'Encontrou cabeçalho'
        case 'all_edges_detected':
            return 'Possível ocultação de contorno'
        case 'found_side_text':
            return 'Encontrou texto lateral'
        case 'screen_display_detected':
            return 'Documento exibido em uma tela'
        case 'is_copy':
            return 'Documento é uma cópia (xerox ou impressão)'
        case 'text_tampering_detected':
            return 'Adulteração de conteúdo'
        case 'face_tampering_detected':
            return 'Foto facial adulterada'
        case 'has_physical_damage':
            return 'Documento apresenta danos físicos'
        case 'has_textual_legibility_issues':
            return 'Problemas de legibilidade'
        case 'found_anomalous_pdf_creator_or_producer':
            return 'Criador ou produtor do PDF é incomum'
        case 'creation_and_modification_date_mismatch':
            return 'Data de criação e modificação do PDF são diferentes'
        case 'cpf_signer_mismatch':
            return 'CPF do assinante divergente do documento'
        default:
            return null
    }
}

export const mapSemanticNegativeValue = (flag) => {
    switch (flag) {
        case 'found_illeterate_person_text':
            return true
        case 'multiple_people':
            return true
        case 'document_edges_issue':
            return true
        case 'found_state_text':
            return false
        case 'found_footer_text':
            return false
        case 'found_header_text':
            return false
        case 'found_anomalous_pdf_creator_or_producer':
            return true
        case 'creation_and_modification_date_mismatch':
            return true
        case 'all_edges_detected':
            return false
        case 'found_side_text':
            return false
        case 'screen_display_detected':
            return true
        case 'is_copy':
            return true
        case 'text_tampering_detected':
            return true
        case 'face_tampering_detected':
            return true
        case 'has_physical_damage':
            return true
        case 'has_textual_legibility_issues':
            return true
        case 'cpf_signer_mismatch':
            return true
        default:
            return null
    }
}

export const mapDocumentTemplateTypeName = (templateType) => {
    switch (templateType) {
        case 'rg_front':
            return 'RG - Frente'
        case 'rg_back':
            return 'RG - Verso'
        case 'cnh_digital':
            return 'CNH Digital'
        case 'cin_digital':
            return 'CIN Digital'
        case 'cnh_front':
            return 'CNH - Frente'
        case 'cnh_back':
            return 'CNH - Verso'
        case 'national_registry_of_foreigners_front':
            return 'RNE - Frente'
        case 'national_registry_of_foreigners_back':
            return 'RNE - Verso'
        case 'national_migration_registry_front':
            return 'RNM - Frente'
        case 'national_migration_registry_back':
            return 'RNM - Verso'
        case 'regional_nursing_council_registry_front':
            return 'COREN - Frente'
        case 'regional_nursing_council_registry_back':
            return 'COREN - Verso'
        case 'ctps_front':
            return 'CTPS - Frente'
        case 'ctps_back':
            return 'CTPS - Verso'
        case 'passport_front':
            return 'Passaporte - Frente'
        case 'passport_back':
            return 'Passaporte - Verso'
        case 'others_front':
            return 'Outro Documento - Frente'
        case 'others_back':
            return 'Outro Documento - Verso'
        default:
            return templateType
    }
}

export const getLatestRuleEngineEvent = (ruleAnalysisEventsData) => {
    const engineEvents = (ruleAnalysisEventsData || [])
        .filter((event) => event && Object.prototype.hasOwnProperty.call(event, 'reason_description'))
    if (engineEvents.length === 0) {
        return null
    }
    return engineEvents[engineEvents.length - 1]
}

export const splitTriggeredRules = (engineEvent) => {
    if (!engineEvent || !Array.isArray(engineEvent.triggered_rules)) {
        return null
    }
    const reproved = engineEvent.triggered_rules.filter((rule) => rule?.decision === 'reproved')
    const manual = engineEvent.triggered_rules.filter((rule) => rule?.decision === 'in_manual_analysis')
    return { reproved, manual }
}

export const getSameIpMatches = (engineEvent) => {
    if (!engineEvent || !Array.isArray(engineEvent.same_ip_matches)) {
        return null
    }
    return engineEvent.same_ip_matches
}

export const triggerFileDownload = (url) => {
    const link = document.createElement('a')
    link.href = url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const getFaceValidationScoreColor = (score) => {
    const numericScore = Number(score)
    if (score === null || score === undefined || score === '' || Number.isNaN(numericScore)) {
        return 'blue'
    }
    if (numericScore >= 60) {
        return 'green'
    }
    if (numericScore >= 50) {
        return 'darkorange'
    }
    return 'red'
}
